import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useCookie } from '../../hooks/use-cookie-value';
import { useLocale } from '../../intl/hooks';
import { getPartitionNumber } from '../../services/partition-service';
import { ShipStationAppId } from '../constants';
import { CheckEnvService } from '../../services/check-env-service';
import Global from '../../store/global-selectors';

export const useCommonCuiProps = () => {
  const isAdmin = useSelector(Global.selectUserisSysAdmin);
  const userId = useSelector(Global.selectUserCurrentUserId);
  const sellerId = useSelector(Global.selectSellerSellerId);
  const authToken = useCookie('auth').cookieValue;
  const auth0Token = useCookie('_lat').cookieValue;
  const auth0V3Token = useCookie('_latv3').cookieValue;
  const impersonationCookie = useCookie('x-imp');
  const impersonationExpirationCookie = useCookie('x-imp-exp');
  const { locale } = useLocale();
  const partition = getPartitionNumber();
  const country = useSelector(Global.selectSellerHomeCountry);
  const user = {
    country,
    isAdmin,
    userId,
    sellerId,
  };

  const commonProps = {
    appId: ShipStationAppId,
    authTokenBucket: useMemo(
      () => ({
        // NOTE: auth0 token holders will still have an `auth` cookie but is string literal "undefined"
        authToken: authToken === 'undefined' ? undefined : authToken,
        auth0Token,
        auth0V3Token,
      }),
      [authToken, auth0Token, auth0V3Token],
    ),
    environment: CheckEnvService.getEnvironmentStringFromDDEStatus(),
    locale,
    partitionId: partition,
    hostUrl: window.location.href,
    user,
  };

  if (impersonationCookie && !Number.isNaN(Number.parseInt(impersonationCookie.cookieValue, 10))) {
    commonProps.impersonationInformation = {
      // expiration is sometimes a number, sometimes not. Leave as a string.
      expiration: impersonationExpirationCookie.cookieValue,
      sellerId: Number.parseInt(impersonationCookie.cookieValue, 10),
    };
  }

  return commonProps;
};
